import { useCallback, useEffect, useState } from 'react'

import {
  getUnreadNotifications,
  transformUnreadNotificationsResponse,
} from '@marketplace-web/inbox-notifications/inbox-notifications-data'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

const useUnreadNotificationsCount = () => {
  const isSvcInboxNotificationsUnreadEndpointWebEnabled = useFeatureSwitch(
    'svc_inbox_notifications_unread_endpoint_web',
  )
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState<number>(0)

  const fetchUnreadNotificationsCount = useCallback(async () => {
    await getUnreadNotifications().then(
      (response: Awaited<ReturnType<typeof getUnreadNotifications>>) => {
        if ('errors' in response) return

        setUnreadNotificationsCount(transformUnreadNotificationsResponse(response))
      },
    )
  }, [])

  useEffect(() => {
    if (isSvcInboxNotificationsUnreadEndpointWebEnabled) {
      fetchUnreadNotificationsCount()
    }
  }, [isSvcInboxNotificationsUnreadEndpointWebEnabled, fetchUnreadNotificationsCount])

  return {
    unreadNotificationsCount,
    fetchUnreadNotificationsCount,
  }
}

export default useUnreadNotificationsCount
